import { render, staticRenderFns } from "./costServingRulesModal.vue?vue&type=template&id=bb36e85e&"
import script from "./costServingRulesModal.vue?vue&type=script&lang=js&"
export * from "./costServingRulesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports